<template>
	<div style="background: #efefef;">

		<!-- 产品相册 -->
		<div class="goods-photo-slider">

			<!--  轮播  -->
			<slider ref="slider" :options="options">
				<slideritem v-for="(item,index) in sliderList" :key="index">
					<img style="width:100%;" :src="item.image">
				</slideritem>
				<div slot="loading">loading...</div>
			</slider>
			<!--  轮播  -->

		</div>

		<div class="goods_info">
			<div>
				<span style="font-size: 0.8rem;color: black;">￥{{goodsInfo.goods_price}}</span>
				<span style="font-size: .5rem;float: right;">已售 {{goodsInfo.goods_view}}</span>
			</div>
			<div>
				<span style="font-size: .6rem;">{{goodsInfo.goods_name}}</span>
			</div>
			<div>
				<span style="font-size: .4rem;">发货</span>
				<span style="font-size: .4rem;margin-left: .6rem;">48小时内发货</span>
			</div>
			<div>
				<span style="font-size: .4rem;">保障</span>
				<span style="font-size: .4rem;margin-left: .6rem;">7天无理由</span>
			</div>
			
			<div>
				<br /> 
			</div>
			
		</div>
		
		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

<!-- 		<div class="goods_info">
			<div>
				<span style="font-size: .5rem;">商品详情</span>
			</div>
			<table>
				<tr>
					<td>材质</td>
					<td>树脂</td>
				</tr>
				<tr>
					<td>使用场景</td>
					<td>客厅</td>
				</tr>
				<tr>
					<td>是否含有贵金属</td>
					<td>无</td>
				</tr>
				<tr>
					<td>产地</td>
					<td>广东汕头</td>
				</tr>
			</table>
		</div> -->

		<div class="photo-list">
				<div v-for="(item,index) in photo_list" :key="index">
					<img :src="item.image_link">
				</div>
		</div>

		<br />
		<br />
		<br />

		<div class='goods-bottom'>
			<div class="btn-kefu">
				<span>客服</span>
			</div>
			<div class='btn-order' @click="buyNow(goodsInfo.goods_id)">立即购买</div>
			<div class='btn-cart' @click="addCart(goodsInfo.goods_id)">加入购物车</div>
		</div>

		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.goods-photo-sliderr {
		width: 100%;
		/* border-bottom: 1px solid #efefef;
		box-shadow: 0px 0px .6rem #ccc; */
	}

	.goods_info {
		padding: .5rem 0;
		padding-left: .5rem;
		background-color: #FFFFFF;
	}

	.goods_info>div {
		padding-left: .5rem;
	}

	.goods_info>div>span {
/* 		display: inline-block;
		color: grey; */
	}

	.goods_info>table {
		border-spacing: 0;
		border-collapse: collapse;
	}

	.goods_info>table>tr>td {
		width: 8rem;
		padding-left: 1rem;
		padding-top: .4rem;
		padding-bottom: .4rem;

		border: 1px solid #ddd;
		border-collapse: collapse;
		font-size: .5rem;
	}



	.photo-list div {
		font-size: 0;
	}
	.photo-list img {
		width: 100%;
	}

	.goods-bottom
	{
		width: 100%;
		height: 3rem;
		
		position:fixed;
		bottom: 0px;
		
		/* border: 1px solid blue; */
		background-color: #ffffff;
	}
	.btn-kefu 
	{
		float:left;
		
		height: 1rem;
		font-size: .6rem;
		margin: 0.5rem 0.5rem;
		
		line-height: 3rem; 
	}
	.btn-cart
	{
		float: right;
		
		margin: 0.5rem 0;
		
		font-size: .7rem;
		color: black;
		text-align: center;

		height: 2rem;
		width: 6rem;
		border: 1px solid lightgrey;
		border-radius: 2rem;
		
		line-height: 2rem; 
	}
	.btn-order
	{
		float: right;

		margin: 0.5rem 0.5rem;
		
		font-size: .7rem;
		color: #FFFFFF;
		text-align: center;
		
		height: 2rem;
		width: 6rem;
		border-radius: 2rem;
		
		line-height: 2rem; 
		
		background-color: #d9001b;
	}

	


		/* 备用的 */
		/* 阻止识别照片 */
		/* pointer-events: none; */
	
</style>
<script>
	import sy from "@/sy";

	// 组件引入
	import syalert from '@/components/syalert.vue';

	// ---------- 引入轮播
	import {
		slider,
		slideritem
	} from 'vue-concise-slider';

	// import img01 from "@/assets/image/goods-1-1.jpg";
	// import img02 from "@/assets/image/goods-1-2.jpg";
	// import img03 from "@/assets/image/goods-1-3.jpg";
	// import img04 from "@/assets/image/goods-1-4.jpg";
	// import img05 from "@/assets/image/goods-1-5.jpg";

	export default {
		name: 'goods',
		components: {
			syalert,
			slider,
			slideritem,
		},
		data() {
			return {
				goodsInfo: {},
				input_box: false,
				input_box_text: '',


				// ---- ---- 轮播参数
				options: {
					currentPage: 0,
					speed: 300,
					itemAnimation: true,
					centeredSlides: true,
					thresholdDistance: 100,
					thresholdTime: 300,
					autoplay: 3000,
					loopedSlides: 2,
					slidesToScroll: 1,
					loop: true
				},
				sliderList: 
				[
					// {image: img01},
				], 
				photo_list: 
				[
					
				],
			}
		},
		methods: {
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},  
			getGoodsInfo: function(gid)
			{
				console.log(gid);
				
				if (gid === undefined)
				{
					console.log('无 gid');
					return false;
				}
				if (gid === '0')
				{
					console.log('无 gid');
					return false;
				}
				// 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Goods/Get',
					data: {
						'gid': gid,
					},
					success: function(res)
					{
						if( res.state === '0' )
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}
						
						//console.log(res.data);
						$_this.goodsInfo = res.data;
						$_this.photo_list = res.data.image_list;
						for(let x of res.data.image_slider )
						{
							$_this.sliderList.push( {image: x.image_link} );
						}
						// console.log(list);
					}
				});
			},
			addCart: function(gid)
			{
				console.log(gid);
				
				if (gid === undefined)
				{
					console.log('无 gid');
					return false;
				}
				if (gid === '0')
				{
					console.log('无 gid');
					return false;
				}
				// 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Cart/Add',
					data: {
						'gid': gid,
					},
					success: function(res)
					{
						return $_this.$refs.syalert_id.syalert(res.msg);
					}
				});
				
				// 组件调用
				// this.$refs.syalert_id.syalert(msg);
			},
			buyNow: function(gid)
			{
				console.log(gid);
				
				if (gid === undefined)
				{
					console.log('无 gid');
					return false;
				}
				if (gid === '0')
				{
					console.log('无 gid');
					return false;
				}
				
				this.$router.push('/order/submit?gid=' + gid);
				
				
				// 接口 Order/Preorder
				// 接口 Order/Preview
				// 接口 Order/Preview
				// console.log(gid + ':' + num);
				
				
				// 组件调用
				// this.$refs.syalert_id.syalert(msg);
			},

		},
		mounted() {
			
		},
		created(){
			// document.body.scrollTop = 0;
			let gid = this.$router.currentRoute.query.gid; 
			
			this.getGoodsInfo(gid);
		}
	}
</script>